<!-- Generic (status, priority, custom fields) -->
@if (ppChange.label === 'Priority') {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_PRIORITY" />
  </span>
}

@if (ppChange.label === 'Status') {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_STATUS" />
  </span>
}

@if (ppChange.propName === EActivityPropName.ASSIGNEES) {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_ASSIGNEES" />
  </span>
}

@if (
  ppChange.propName === EActivityPropName.POINT_COPY ||
  ppChange.propName === EActivityPropName.POINT_COPY_FROM ||
  ppChange.propName === EActivityPropName.POINT_COPY_TO
  ) {
  <span
    class="activityChange__icon"
    >
    <img
      class="activityChange__icon-svg activityChange__icon--copy"
      [src]="EIconPath.BASIC_FIELD_COPY"
      />
  </span>
}

@if (
  ppChange.propName === EActivityPropName.POINT_MOVE ||
  ppChange.propName === EActivityPropName.POINT_MOVE_FROM ||
  ppChange.propName === EActivityPropName.POINT_MOVE_TO
  ) {
  <span
    class="activityChange__icon"
    >
    <img
      class="activityChange__icon-svg activityChange__icon--move"
      [src]="EIconPath.POINT_ACTIVITY_MOVE"
      />
  </span>
}

@switch (type) {
  @case (ECustomFieldType.TEXT) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_TEXT_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.LIST) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_LIST_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.CHECKBOX) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_CHECKBOX_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.DATE) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_DATE_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.TIME) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_TIME_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.COST) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_COST_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.NUMBERS) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_NUMBERS_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.PERCENTAGE) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_PERCENTAGE_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.TIMELINE) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_TIMELINE_ACTIVITY" />
    </span>
  }
  @case (ECustomFieldType.RICHTEXT) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.CUSTOM_FIELD_RICH_TEXT_ACTIVITY" />
    </span>
  }
  @case (EIntegrationStatus.DISABLED) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL" />
    </span>
  }
  @case (EIntegrationStatus.ON) {
    <span class="activityChange__icon">
      <img class="activityChange__icon-svg" [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL" />
    </span>
  }
}

@if (
  ppChange.generic &&
  ppChange.propName !== EActivityPropName.ADDITIONAL_PINS &&
  ppChange.propName !== EActivityPropName.POLYGONS &&
  ppChange.propName !== EActivityPropName.PINS &&
  ppChange.propName !== EActivityPropName.CUSTOM_FIELD_SUB_VALUE &&
  ppChange.cfFieldType !== ECustomFieldType.MULTI_LIST
  ) {
  <div
    class="activityChange"
    >
    @if (ppChange.oldValue || ppChange.newValue) {
      <span>
        @if (
          ppChange.propName === EActivityPropName.POINT_MOVE ||
          ppChange.propName === EActivityPropName.POINT_MOVE_FROM ||
          ppChange.propName === EActivityPropName.POINT_MOVE_TO
          ) {
          <span
            >{{ 'moved_this_point' | ppTranslate }}
            <strong class="timeline__strong">{{ ppChange.label }}</strong>
          </span>
        }
        @if (
          ppChange.propName === EActivityPropName.POINT_COPY ||
          ppChange.propName === EActivityPropName.POINT_COPY_FROM ||
          ppChange.propName === EActivityPropName.POINT_COPY_TO
          ) {
          <span
            >{{ 'copied_this_point' | ppTranslate }}
            <strong class="timeline__strong">{{ ppChange.label }}</strong>
          </span>
        }
        @if (
          ppChange.propName !== EActivityPropName.POINT_COPY &&
          ppChange.propName !== EActivityPropName.POINT_COPY_FROM &&
          ppChange.propName !== EActivityPropName.POINT_COPY_TO &&
          ppChange.propName !== EActivityPropName.POINT_MOVE_FROM &&
          ppChange.propName !== EActivityPropName.POINT_MOVE_TO &&
          ppChange.propName !== EActivityPropName.POINT_MOVE
          ) {
          <span
            >
            @if (!(ppChange.oldValue && !ppChange.newValue)) {
              <span>Changed </span>
            }
            <span class="customField__label">
              <strong
                class="timeline__strong customField__label--text"
                ppTooltip
                [ppTrimTooltip]="true"
                [ppTitle]="ppChange.label"
                >
                {{ ppChange.label }}
              </strong>
            </span>
          </span>
        }
      </span>
    }
    @if (
      ((ppChange.propName === EActivityPropName.POINT_MOVE ||
      ppChange.propName === EActivityPropName.POINT_COPY) &&
      ppChange.oldValue) ||
      ppChange.propName === EActivityPropName.POINT_MOVE_TO ||
      ppChange.propName === EActivityPropName.POINT_COPY_TO ||
      ppChange.propName === EActivityPropName.POINT_MOVE_FROM ||
      ppChange.propName === EActivityPropName.POINT_COPY_FROM
      ) {
      <span
        >
        {{ 'from' | ppTranslate }} <strong class="timeline__strong">{{ ppChange.oldValue }}</strong>
      </span>
    }
    @if (ppChange.oldValue && !ppChange.newValue) {
      <span> {{ 'was_cleared' | ppTranslate }} </span>
    }
    @if (ppChange.oldValue && ppChange.newValue) {
      <span>
        {{ 'to' | ppTranslate | lowercase }}
        <strong
          class="timeline__strong activityChange--{{ statusPriorityToColor(stringChange.newValue) }}"
          >{{ humanizeActivityChange(stringChange.newValue) }}.</strong
          >
        </span>
      }
      @if (!ppChange.oldValue && ppChange.newValue) {
        <span>
          {{ 'to' | ppTranslate | lowercase }}
          <strong
            class="timeline__strong"
            [ngClass]="{ 'timeline__no-wrap': type === 'DATE' || type === 'TIMELINE' }"
            >{{ ppChange.newValue }}.</strong
            >
          </span>
        }
      </div>
    }

    @if (
      ppChange.propName === EActivityPropName.ADDITIONAL_PINS ||
      ppChange.propName === EActivityPropName.POLYGONS ||
      ppChange.propName === EActivityPropName.PINS
      ) {
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_LOCATION" />
      </span>
      <div class="activityChange">{{ 'changed_location' | ppTranslate }}.</div>
    }

    <!-- Location -->
    @if (ppChange.propName === EActivityPropName.PIN) {
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_LOCATION" />
      </span>
    }

    @if (ppChange.propName === EActivityPropName.PIN) {
      <div class="activityChange">
        @if (ppChange.oldValue && !ppChange.newValue) {
          {{ 'location_removed' | ppTranslate }}.
        }
        @if (!(ppChange.oldValue && !ppChange.newValue)) {
          {{ 'changed_location' | ppTranslate }}.
        }
      </div>
    }

    <!-- Title -->
    @if (ppChange.propName === EActivityPropName.TITLE) {
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_TITLE" />
      </span>
    }

    @if (ppChange.propName === EActivityPropName.TITLE) {
      <div class="activityChange">
        {{ 'changed' | ppTranslate }} <strong class="timeline__strong"> Title </strong> to
        <strong class="timeline__strong">{{ ppChange.newValue }}.</strong>
      </div>
    }

    <!--Subfields-->
    @if (ppChange.propName === EActivityPropName.CUSTOM_FIELD_SUB_VALUE) {
      <span class="activityChange">
        <strong class="timeline__strong" ppTooltip [ppTrimTooltip]="true" [ppTitle]="ppChange.label">
          {{ ppChange.label }}
        </strong>
        <span> {{ 'subfield' | ppTranslate }} </span>
        @if (ppChange.newValue && !ppChange.oldValue) {
          <span
            >{{ 'added' | ppTranslate }}
            <span class="activityChange__item-quoted"> {{ ppChange.newValue }}</span>
          </span>
        }
        @if (ppChange.newValue && ppChange.oldValue) {
          <span>
            {{ 'updated_to' | ppTranslate }}
            <span class="activityChange__item-quoted">{{ ppChange.newValue }}</span></span
            >
          }
          @if (!ppChange.newValue && ppChange.oldValue) {
            <span
              ><span class="activityChange__item-quoted">{{ ppChange.newValue }}</span>
              {{ 'deleted' | ppTranslate }}</span
              >
            }
          </span>
        }

        <!-- Red Flag -->
        @if (ppChange.propName === EActivityPropName.FLAGGED) {
          <span class="activityChange__icon">
            @if (!ppChange.newValue) {
              <pp-icon
                class="activityChange__icon-svg"
                [ppSVG]="iconMap[EIconPath.ICON_ACTIVITIES_RED_FLAG_14]"
                ppClass="setSize14"
                ppColor="grey-500"
                />
            }
            @if (ppChange.newValue) {
              <img
                class="activityChange__icon-svg"
                [src]="EIconPath.ICON_ACTIVITIES_RED_FLAG_ACTIVATED_14"
                />
            }
          </span>
        }

        @if (ppChange.propName === EActivityPropName.FLAGGED) {
          <div class="activityChange">
            @if (ppChange.newValue) {
              {{ 'point_flagged' | ppTranslate }}
            }
            @if (!ppChange.newValue) {
              {{ 'point_unflagged' | ppTranslate }}
            }
          </div>
        }

        <!-- Description -->
        @if (ppChange.propName === EActivityPropName.DESCRIPTION) {
          <span class="activityChange__icon">
            <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_DESCRIPTION" />
          </span>
        }

        @if (ppChange.propName === EActivityPropName.DESCRIPTION && ppChange.newValue) {
          <div
            class="activityChange"
            >
            {{ 'changed' | ppTranslate }} <strong class="timeline__strong">Description</strong> to
            <pp-description-activity [ppPlainText]="stringChange.newValue"></pp-description-activity>
          </div>
        }

        @if (ppChange.propName === EActivityPropName.DESCRIPTION && !ppChange.newValue) {
          <div
            class="activityChange"
            >
            <strong class="timeline__strong">Description</strong> was cleared.
          </div>
        }

        @if (ppChange.propName === EActivityPropName.DESCRIPTION_RICH) {
          <span class="activityChange__icon">
            <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_DESCRIPTION" />
          </span>
        }

        @if (ppChange.propName === EActivityPropName.DESCRIPTION_RICH) {
          <div class="activityChange">
            {{ 'changed' | ppTranslate }} <strong class="timeline__strong">Description</strong> to:
            <pp-description-activity [ppDescription]="stringChange.newValue"></pp-description-activity>
          </div>
        }

        <div>
          <!-- Added tags -->
          <div class="activityChange--tag">
            @if (ppChange.propName === EActivityPropName.TAGS && stringsChange.added.length) {
              <span
                class="activityChange__icon"
                >
                <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_TAGS" />
              </span>
            }

            @if (ppChange.propName === EActivityPropName.TAGS && stringsChange.added.length) {
              <div
                class="activityChange activityChange--taller"
                >
                <span class="activityChange__tag-description"> {{ 'added' | ppTranslate }} </span>
                @for (value of stringsChange.added; track value) {
                  <span class="activityChange__tag">
                    <pp-tag [ppText]="value" [ppDeletable]="false" [ppDisabled]="true"></pp-tag>
                  </span>
                }
              </div>
            }
          </div>

          <!-- Removed tags -->
          <div class="activityChange--tag">
            @if (ppChange.propName === EActivityPropName.TAGS && ppChange.deleted.length) {
              <span
                class="activityChange__icon"
                >
                <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_TAGS" />
              </span>
            }

            @if (ppChange.propName === EActivityPropName.TAGS && ppChange.deleted.length) {
              <div
                class="activityChange activityChange--taller"
                >
                <span class="activityChange__tag-description"> {{ 'removed' | ppTranslate }} </span>
                @for (value of stringsChange.deleted; track value) {
                  <span class="activityChange__tag">
                    <pp-tag [ppText]="value" [ppDeletable]="false" [ppDisabled]="true"></pp-tag>
                  </span>
                }
              </div>
            }
          </div>
        </div>

        @if (ppChange.cfFieldType === ECustomFieldType.MULTI_LIST) {
          <div
            class="activityChange__multi-select"
            >
            <pp-multi-select-activity [ppChange]="ppChange"></pp-multi-select-activity>
          </div>
        }

        <!-- Changed rich text CF -->

        @if (type === 'RICHTEXT') {
          <div class="activityChange">
            @if (ppChange.oldValue && !ppChange.newValue) {
              <span>
                <span class="customField__label">
                  <strong
                    class="timeline__strong customField__label--text"
                    ppTooltip
                    [ppTrimTooltip]="true"
                    [ppTitle]="ppChange.label"
                    >
                    {{ ppChange.label }}
                  </strong>
                </span>
                {{ 'was_cleared' | ppTranslate }}.
              </span>
            }
            @if (ppChange.newValue) {
              <span>
                {{ 'changed' | ppTranslate }}
                <span class="customField__label">
                  <strong
                    class="timeline__strong customField__label--text"
                    ppTooltip
                    [ppTrimTooltip]="true"
                    [ppTitle]="ppChange.label"
                    >
                    {{ ppChange.label }}
                  </strong>
                </span>
                {{ 'to' | ppTranslate | lowercase }}:
              </span>
            }
            @if (stringChange.newValue) {
              <pp-description-activity
                [ppDescription]="stringChange.newValue"
              ></pp-description-activity>
            }
          </div>
        }

        <!-- Added assignees -->

        @if (stringsChange.propName === EActivityPropName.ASSIGNEES && stringsChange.added.length) {
          <div
            class="activityChange activityChange--taller"
            >
            <span class="activityChange__assignees-label">{{ 'added' | ppTranslate }}</span>
            @for (userId of stringsChange.added; track userId; let last = $last) {
              <span
                class="activityChange__assignee"
                >
                @if (allUsers[userId]) {
                  @if (allUsers[userId].avatarPublicUrl) {
                    <img
                      ppImage
                      loading="lazy"
                      [src]="allUsers[userId].avatarPublicUrl"
                      class="activityChange__assignee--avatar"
                      />
                  }
                  @if (!allUsers[userId].avatarPublicUrl) {
                    <img
                      class="activityChange__assignee--avatar"
                      [src]="EIconPath.BASIC_FIELD_ASSIGNEES"
                      />
                  }
                  <span class="activityChange__assignee--userName">
                    {{ allUsers[userId].userName }}@if (!last) {
                    <span>,</span>
                  }
                  @if (last) {
                    <span>.</span>
                  }
                </span>
              }
              @if (!allUsers[userId]) {
                - ({{ 'deleted_user' | ppTranslate }})@if (!last) {
                <span>,</span>
              }
              @if (last) {
                <span>.</span>
              }
            }
          </span>
        }
      </div>
    }

    <!-- Removed assignees -->
    @if (ppChange.propName === EActivityPropName.ASSIGNEES && stringsChange.deleted.length) {
      <div
        class="activityChange activityChange--taller"
        >
        <span class="activityChange__assignees-label">{{ 'removed' | ppTranslate }}</span>
        @for (userId of stringsChange.deleted; track userId; let last = $last) {
          <span
            class="activityChange__assignee"
            >
            @if (allUsers[userId]) {
              @if (allUsers[userId].avatarPublicUrl) {
                <img
                  ppImage
                  loading="lazy"
                  [src]="allUsers[userId].avatarPublicUrl"
                  class="activityChange__assignee--avatar"
                  />
              }
              @if (!allUsers[userId].avatarPublicUrl) {
                <img
                  class="activityChange__assignee--avatar"
                  [src]="EIconPath.BASIC_FIELD_ASSIGNEES"
                  />
              }
              <span class="activityChange__assignee--userName">
                {{ allUsers[userId].userName }}@if (!last) {
                <span>,</span>
              }
              @if (last) {
                <span>.</span>
              }
            </span>
          }
          @if (!allUsers[userId]) {
            <ng-container class="activityChange__assignee--userName">
              - ({{ 'deleted_user' | ppTranslate }})@if (!last) {
              <span>,</span>
            }
            @if (last) {
              <span>.</span>
            }
          </ng-container>
        }
      </span>
    }
  </div>
}

<!-- Added file, 360 images, video, photos -->
@if (
  (ppChange.propName === EActivityPropName.DOCUMENTS ||
  ppChange.propName === EActivityPropName.IMAGES_360 ||
  ppChange.propName === EActivityPropName.VIDEOS ||
  ppChange.propName === EActivityPropName.IMAGES) &&
  (ppChange.added.length || ppChange.filesChange === 'ADDED')
  ) {
  <pp-attachment-added-activity
    (ppOpenGallery)="openGallery($event)"
    [ppMediaAttachments]="media.attachments"
    [ppChange]="ppChange"
  ></pp-attachment-added-activity>
}

<!-- Deleted file, 360 images, video, photos -->
@if (
  (ppChange.propName === EActivityPropName.DOCUMENTS ||
  ppChange.propName === EActivityPropName.IMAGES_360 ||
  ppChange.propName === EActivityPropName.VIDEOS ||
  ppChange.propName === EActivityPropName.IMAGES) &&
  (ppChange.deleted.length || ppChange.filesChange === 'DELETED')
  ) {
  <pp-attachment-deleted-activity
    [ppChange]="ppChange"
  ></pp-attachment-deleted-activity>
}
